import ObexRequestHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { buildQuery, unwrapList, getErrorMessage, getAccessToken } from './apiUtils';

const ROUTES = {
    list: '/warehouses_list'
};

export interface Warehouse {
    id: string;
    name: string;
}

/**
 * Los almacenes no cambian durante un turno de caja, y la consulta se repite por
 * cada libro sin stock que el cajero despliega: se guardan tras la primera.
 */
let cache: Warehouse[] | null = null;

export const listWarehouses = async (): Promise<Warehouse[]> => {
    if (cache) return cache;

    const accessToken = getAccessToken();
    if (!accessToken) throw new Error('No autorizado');

    const res = await ObexRequestHandlerP80.get(
        `${ROUTES.list}${buildQuery({
            access_token: accessToken,
            status: 'active',
            page: 1,
            page_size: 100
        })}`
    );

    const error = getErrorMessage(res);
    if (error) throw new Error(error);

    cache = unwrapList(res).map(raw => ({
        id: String(raw.id),
        name: raw.name || `Almacén ${raw.id}`
    }));
    return cache;
};
